import { SortDirection } from '../../config/constants';
import { EmissionSpoolsAction, EmissionSpoolsType } from './emissionSpoolsType';

const emissionSpoolsReducer = (
    state: EmissionSpoolsType,
    action: EmissionSpoolsAction
): EmissionSpoolsType => {
    switch (action.type) {
        case 'SET_SEARCH_TERM':
            return {
                ...state,
                searchTerm: action.payload,
            };
        case 'SET_ACTIVE_SORT':
            return {
                ...state,
                activeSort: action.payload,
            };
        case 'CHANGE_ACTIVE_SORT_DIRECTION':
            return {
                ...state,
                activeSort: {
                    ...state.activeSort,
                    direction:
                        state.activeSort.direction === SortDirection.ASC
                            ? SortDirection.DESC
                            : SortDirection.ASC,
                },
            };
        case 'SET_ALLOCATION':
            return {
                ...state,
                totalInputAlloc: { ...state.totalInputAlloc, ...action.payload },
            };
        case 'SET_TOTAL_ALLOCATION_AMOUNT':
            return {
                ...state,
                totalAllocAmount: action.payload,
            };
        case 'SET_USER_HAS_VOTED':
            return {
                ...state,
                userHasVoted: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default emissionSpoolsReducer;
